import { Outlet } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SchemaOrg from '@/components/feature/SchemaOrg';

export default function Layout() {
  return (
    <>
      <ScrollToTop />
      <SchemaOrg />
      <Navbar />
      <main className="min-h-screen">
        <Outlet />
      </main>
      <Footer />
    </>
  );
}